export default __webpack_public_path__ + "static/media/union.0b81cd33.svg";